/**
 * @generated SignedSource<<b8f3015601332ae330fabf46541fe4ed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskFragmentScheduleItem$data = {
  readonly scheduleItem: {
    readonly duration: string | null | undefined;
    readonly end_format_datetime: string | null | undefined;
    readonly id: string | null | undefined;
    readonly name: string;
    readonly project: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly number: string | null | undefined;
    } | null | undefined;
    readonly start_format_datetime: string | null | undefined;
    readonly status: number | null | undefined;
    readonly statusItem: {
      readonly name: string;
    } | null | undefined;
    readonly type: number | null | undefined;
    readonly typeItem: {
      readonly name: string;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"ScheduleItemFragment">;
  } | null | undefined;
  readonly " $fragmentType": "TaskFragmentScheduleItem";
};
export type TaskFragmentScheduleItem$key = {
  readonly " $data"?: TaskFragmentScheduleItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaskFragmentScheduleItem">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskFragmentScheduleItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ScheduleItem",
      "kind": "LinkedField",
      "name": "scheduleItem",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "start_format_datetime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "end_format_datetime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "duration",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Project",
          "kind": "LinkedField",
          "name": "project",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "number",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ListItem",
          "kind": "LinkedField",
          "name": "statusItem",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ListItem",
          "kind": "LinkedField",
          "name": "typeItem",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ScheduleItemFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Task",
  "abstractKey": null
};
})();

(node as any).hash = "63568e895de70a39369774942a3e9cee";

export default node;
